import { config } from "@/config";
export class ClienteAlMayorService {
    static getHeaders() {
        return {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        };
    }
    static async getAll(page = 1, search = "", letter = "") {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (search)
            params.append("search", search);
        if (letter)
            params.append("letter", letter);
        const response = await fetch(`${config.API_URL}/api/ClienteAlMayor?${params.toString()}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener la lista de clientes");
        return response.json();
    }
    static async getById(id) {
        const response = await fetch(`${config.API_URL}/api/ClienteAlMayor/${id}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al obtener el cliente");
        return response.json();
    }
    static async buscarPorDocumento(tipoDocId, numero) {
        const response = await fetch(`${config.API_URL}/api/ClienteAlMayor/buscar?tipoDocId=${tipoDocId}&numero=${encodeURIComponent(numero)}`, {
            method: "GET",
            headers: this.getHeaders(),
        });
        // No lanzamos error en 404 para que el formulario sepa que el cliente no existe y permita el registro
        if (!response.ok && response.status !== 404) {
            throw new Error("Error en la búsqueda de documento");
        }
        return response.json();
    }
    static async addCliente(cliente) {
        const response = await fetch(`${config.API_URL}/api/ClienteAlMayor`, {
            method: "POST",
            headers: this.getHeaders(),
            body: JSON.stringify(cliente),
        });
        if (!response.ok)
            throw new Error("Error al registrar cliente");
        return response.json();
    }
    static async updateCliente(id, cliente) {
        const response = await fetch(`${config.API_URL}/api/ClienteAlMayor/${id}`, {
            method: "PUT",
            headers: this.getHeaders(),
            body: JSON.stringify(cliente),
        });
        if (!response.ok)
            throw new Error("Error al actualizar cliente");
        return response.json();
    }
    static async deleteCliente(id) {
        const response = await fetch(`${config.API_URL}/api/ClienteAlMayor/${id}`, {
            method: "DELETE",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al deshabilitar cliente");
        return response.json();
    }
    static async toggleActivo(id) {
        const response = await fetch(`${config.API_URL}/api/ClienteAlMayor/${id}/activo`, {
            method: "PUT",
            headers: this.getHeaders(),
        });
        if (!response.ok)
            throw new Error("Error al cambiar estado del cliente");
        return response.json();
    }
}
